import type { CSSProperties } from "react";
import { DollarOutlined, FileTextOutlined, BankOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import usePermissions from "../../hooks/usePermissions";
import { AddCashRoute, AddExpenseRoute, BankDepositRoute } from "../../routes/routepath";
import "./styles.scss";

// Quick-add shortcuts (footer menu group: footerAddCash/footerAddExpense/
// footerBankDeposit). SUPERADMIN already has full sidebar access to these
// forms, so this bar is only for roles that were explicitly granted the
// footer permissions.
const ACTIONS = [
  { key: 'cash',    label: 'Add Cash',     icon: <DollarOutlined />,   route: AddCashRoute,    permission: 'CASH_CREATE',         color: '#52c41a' },
  { key: 'expense', label: 'Add Expense',  icon: <FileTextOutlined />, route: AddExpenseRoute, permission: 'VENDOR_CREATE',       color: '#6366f1' },
  { key: 'deposit', label: 'Bank Deposit', icon: <BankOutlined />,     route: BankDepositRoute, permission: 'BANK_DEPOSIT_CREATE', color: '#1890ff' },
];

const QuickActionFooter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission, isSuperAdmin, permissionsLoaded } = usePermissions();

  if (isSuperAdmin || !permissionsLoaded) return null;

  const visibleActions = ACTIONS.filter(a => hasPermission(a.permission));
  if (!visibleActions.length) return null;

  return (
    <div className="quick-action-footer">
      <div className="qaf-inner">
        {visibleActions.map(a => (
          <button
            key={a.key}
            type="button"
            className={`qaf-btn ${location.pathname === a.route ? 'is-active' : ''}`}
            style={{ '--qaf-color': a.color } as CSSProperties}
            onClick={() => navigate(a.route)}
          >
            <span className="qaf-icon">{a.icon}</span>
            <span className="qaf-label">{a.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionFooter;
